const LeftChevronSvg = ({
  height = 24,
  width = 24,
  viewBox = '0 0 24 24',
  className = '',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  className?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" className={className}>
      <path
        d="M15 19L8 12L15 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default LeftChevronSvg;
